(() => {
  // One delegated listener serves every Nuvialle FAQ on the page (and theme editor reloads).
  if (window.__nuvialleFaq) return;
  window.__nuvialleFaq = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isOpen = (item) => item.dataset.nvOpen === '1' || (item.dataset.nvOpen === undefined && item.open);

  const toggle = (item, open) => {
    item.dataset.nvOpen = open ? '1' : '0';
    const wrap = item.querySelector('.nv-faq__a-wrap');
    if (!wrap || reduceMotion) {
      item.open = open;
      return;
    }
    if (wrap.nvCancel) wrap.nvCancel();

    if (open) {
      item.open = true;
      wrap.style.height = '0px';
    } else {
      wrap.style.height = `${wrap.scrollHeight}px`;
    }
    void wrap.offsetHeight;
    wrap.style.height = open ? `${wrap.scrollHeight}px` : '0px';

    const finish = () => {
      cleanup();
      if (open) {
        wrap.style.height = 'auto';
      } else {
        item.open = false;
        wrap.style.height = '';
      }
    };
    const onEnd = (e) => {
      if (e.target === wrap && e.propertyName === 'height') finish();
    };
    // Safety net when transitionend never fires (background tab, interrupted transition).
    const timer = setTimeout(finish, 400);
    const cleanup = () => {
      clearTimeout(timer);
      wrap.removeEventListener('transitionend', onEnd);
      wrap.nvCancel = null;
    };
    wrap.addEventListener('transitionend', onEnd);
    wrap.nvCancel = cleanup;
  };

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.nv-faq__q');
    if (!summary) return;
    const item = summary.parentElement;
    const list = item.closest('[data-nv-faq-list]');
    if (!list) return;
    e.preventDefault();
    const open = !isOpen(item);
    if (open && list.dataset.singleOpen === 'true') {
      list.querySelectorAll('.nv-faq__item').forEach((other) => {
        if (other !== item && isOpen(other)) toggle(other, false);
      });
    }
    toggle(item, open);
  });
})();
